import { render } from "./Making.vue?vue&type=template&id=4134d7e6"
import script from "./Making.vue?vue&type=script&lang=js"
export * from "./Making.vue?vue&type=script&lang=js"

import exportComponent from "/Users/flian/Documents/inncom/2103.artemishosp.line.vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__